import * as Yup from "yup";

export const DirectorySchema = Yup.object().shape({
    title: Yup.string().required("Пожалуйста, укажите название"),
});
